import React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import CallPage from './components/Pages/CallPage';
import AdvancedCallAnalysisPage from './components/Report/AdvancedCallAnalysis';
import LandingPage from './components/Pages/LandingPage';
import Scenarios from './components/Pages/Scenarios';
import ApiStatusChecker from './components/Pages/ApiStatusChecker';
import LoginPage from './components/Pages/LoginPage';
import { ThemeProvider } from './ThemeContext';
import { AuthProvider } from './hooks/AuthContext';
import ProtectedRoute from './components/Pages/ProtectedRoute';
import './theme.css';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <Router>
     
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/" element={<ProtectedRoute><LandingPage /></ProtectedRoute>} />
              <Route path="/scenarios/:type" element={<ProtectedRoute><Scenarios /></ProtectedRoute>} />
              <Route path="/call/:id" element={<ProtectedRoute><CallPage /></ProtectedRoute>} />
              <Route path="/post-call-analysis" element={<ProtectedRoute><AdvancedCallAnalysisPage /></ProtectedRoute>} />
            </Routes>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;